export const restrictedLocationRouteNames = {
  default: 'restricted_location',
}
